<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <div>
        <span class="page-title">资料详情</span>
      </div>
    </div>

    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field field-label__bold">资料名称</span>
            </div>
            <div class="field-content">
              {{ doc.docName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">说明</span>
            </div>
            <div class="field-content">
              {{ doc.docDescription }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">附件</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <p v-if="attachment.docList.length===0">--暂无--</p>
                <p v-for="doc in attachment.docList" :key="doc.uid">
                  <a @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                  <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DocPreview ref="docPreview" />
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import DocPreview from "@/views/DocPreview.vue";
import {loadDoc} from "@/services/RefDocApi";

export default {
  components: {DocPreview, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      pageTitle: "新增资料",
      id: "",
      doc: {
        docId: "",
        docName: "",
        docDescription: "",
      },
      headers: {
        authorization: 'authorization-text',
      },
      uploadUrl: baseURL + "/upload/spec",
      viewUrl: baseURL + "/attachment?fileName=",
      attachment: {
        loading: false,
        docList: [],
        title: "资料文件"
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    if(this.id==='0') {
      this.id = "";
    } else {
      this.pageTitle = "编辑资料";
    }
  },
  mounted() {
    this.startLoadDoc();
  },
  methods: {
    preview(doc) {
      this.$refs.docPreview.previewFile(doc);
    },
    download(doc){
      window.open(doc.url, '_blank');
    },
    changeToAbsImgPath(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      return fileList;
    },
    // 预览已上传文件
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    },
    startLoadDoc() {
      if (this.id && this.id !== "") {
        loadDoc(this.id).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let bizData = resp.data.data;
            this.doc = bizData;
            this.buildDocList(bizData.attachmentDocList, 'attachment');
          } else {
            this.$message.error("读取信息失败");
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    showListPage() {
      this.$router.push({ name: "RefDocList" });
    },
    validateForm(){
      if(!this.doc.docName) {
        return "请输入资料名称";
      }
      return "";
    },

  }
}
</script>
<style scoped>

.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.draft-btn {
  margin-right: 30px;
}
.download-btn {
  margin-right: 30px;
}
</style>
